/**
 * Created by TzuHsing on 2020-02-17
 */

import React, { Component } from 'react'
import { CheckOutlined, CloseOutlined, EditOutlined } from '@ant-design/icons'
import {
  Button,
  Input,
  InputNumber,
  Upload,
  Pagination,
  message,
  Spin,
} from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import { OK, FAILTOUPDATEADV } from '../constants'
import noImg from '../../../assert/images/noimg.svg'
import img from '../../../assert/images/delete.svg'
import { IMAGE_DOMAIN } from '../../../config'
const UPLOADED = 3
const UNPUBLISHED = 2
const UNCHECK = 1
const DELETED = 4
class AdvManageGoods extends Component {
  state = {
    loading: true,
    isTyping: '',
    isIdxTyping: '',
    typingText: '',
    firstType: true, //用于验证input第一次输入时补全它的value值
    fileList: [],
    previewVisible: false,
    previewImage: '',
    qiuNiuToken: '',
    currentPage: 1,
    pageSize: 8,
  }
  componentDidMount() {
    this.getAdvInfo(() => {
      this.setState({ loading: false })
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.clubId != this.props.clubId)
      this.getAdvInfo(() => {
        this.checkPageShouldChange()
      })
  }
  handleNoImg = (e) => {
    e.target.onError = null
    e.target.src = noImg
  }

  getAdvInfo = (callback) => {
    const { clubId, getAdvInfo, advState } = this.props
    getAdvInfo(clubId, advState, () => {
      callback && callback()
    })
  }

  returnEditingEle = (key, value, item) => {
    const handleClose = () => this.setState({ isTyping: '', firstType: true })
    const handleTyping = (e) => this.setState({ typingText: e.target.value })
    const handleTypingNumber = (number) => this.setState({ typingText: number })
    const returnEle = () => {
      if (key === 'num') {
        return (
          <div className="inSideFlexDisplay carBoxValue">
            <InputNumber
              size="small"
              value={this.state.typingText}
              style={{ width: '80%' }}
              onChange={handleTypingNumber}
            />
            <Button
              shape="circle"
              type="primary"
              icon={<CheckOutlined />}
              size="small"
              style={{ margin: '0 6px' }}
              onClick={() => this.handleChangeAdv(item)}
            />
            <Button
              shape="circle"
              type="primary"
              danger
              icon={<CloseOutlined />}
              size="small"
              onClick={handleClose}
            />
          </div>
        )
      } else if (key === 'string') {
        return (
          <div className="inSideFlexDisplay carBoxValue">
            <Input
              size="small"
              value={this.state.typingText}
              style={{ width: '80%' }}
              onChange={handleTyping}
            />
            <Button
              shape="circle"
              type="primary"
              icon={<CheckOutlined />}
              size="small"
              style={{ margin: '0 6px' }}
              onClick={() => this.handleChangeAdv(item)}
            />
            <Button
              shape="circle"
              type="primary"
              danger
              icon={<CloseOutlined />}
              size="small"
              onClick={handleClose}
            />
          </div>
        )
      }
    }
    if (this.state.firstType) {
      this.setState({ typingText: value, firstType: false }, () => returnEle())
    } else {
      return returnEle()
    }
  }

  handleChangeAdv = (item) => {
    const { advState, getAdvInfo, clubId } = this.props
    let body = {
      id: item.id,
      [this.state.isTyping]: this.state.typingText,
    }
    this.props.changeAdvInfo(body, (res) => {
      this.setState({ isTyping: '', firstType: true }, () => {
        if (res.status === OK) {
          this.getAdvInfo(() => {
            if (advState !== UNCHECK && this.state.isTyping !== 'order') {
              getAdvInfo(clubId, UNCHECK)
            }
            this.checkPageShouldChange()
          })
          message.success('操作成功')
        } else {
          this.getAdvInfo()
          message.success(res.detail)
        }
      })
    })
  }

  handleReUpload = (fileList, id) => {
    const { clubId, getAdvInfo, advState } = this.props
    this.setState({ fileList }, () => {
      if (this.state.fileList.fileList[0].status === 'done') {
        this.props.changeAdvInfo(
          { id: id, image_url: this.state.fileList.fileList[0].response.url },
          (res) => {
            if (res.status === OK) {
              message.success('操作成功')
              this.setState({ fileList: [] })
              getAdvInfo(clubId, UNCHECK)
              this.getAdvInfo(() => {
                if (advState !== UNCHECK) {
                  getAdvInfo(clubId, UNCHECK)
                }
                this.checkPageShouldChange()
              })
            } else {
              this.getAdvInfo()
              message.success(res.detail)
            }
          }
        )
      }
    })
  }
  beforeUpload = async (file) => {
    const res = /(image\/png)|(image\/jpeg)/
    if (res.test(file.type)) {
      return await this.props.fetchQiuNiuToken(this)
    } else {
      this.setState({ qiuNiuToken: '' })
      message.error('只能上传 JPG/PNG 格式的图片!')
      return Upload.LIST_IGNORE
    }
  }

  returnEditEle = (value, name, item, idx) => {
    return (
      <div className="inSideFlexDisplay carBoxValue">
        <span
          style={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            marginRight: '.5rem',
          }}
        >
          {value}
        </span>
        <span>
          <EditOutlined onClick={() => this.handleEditing(name, idx)} />
        </span>
      </div>
    )
  }

  handleEditing = (name, idx) => {
    this.setState({ isTyping: name, isIdxTyping: idx })
  }

  handleChangeAdvState = (id, advState, state) => {
    const { clubId, getAdvInfo } = this.props
    let sendState = state
      ? DELETED
      : advState === 1
      ? UNCHECK
      : advState === 2
      ? UPLOADED
      : advState === 3
      ? UNPUBLISHED
      : UNCHECK
    this.props.changeAdvState(
      {
        id: id,
        state: sendState, //state对应的操作：1  adv=>待审核  2 adv=》待发布
      },
      (res) => {
        //3 adv=>已发布  4 adv=>已删除
        if (res.status === OK) {
          message.success('操作成功')
          this.getAdvInfo(() => {
            this.checkPageShouldChange()
          })
          if (state) {
            getAdvInfo(clubId, state)
          } else {
            getAdvInfo(clubId, sendState)
          }
        } else if (res.status === FAILTOUPDATEADV) {
          this.getAdvInfo()
          message.success(res.detail)
        }
      }
    )
  }
  //处理分页功能
  checkPageShouldChange = () => {
    const { advList, advState } = this.props
    const { currentPage, pageSize } = this.state
    if (
      this.getAdvList(advState, advList).slice(
        (currentPage - 1) * pageSize,
        (currentPage - 1) * pageSize + pageSize
      ).length === 0
    ) {
      this.setState({ currentPage: 1 })
    }
  }
  handleChangePage = (page) => {
    this.setState({ currentPage: page })
  }

  getAdvList = (advState, advList) => {
    return advState === 3
      ? advList.adv_uploadedList
      : advState === 2
      ? advList.adv_unpublishedList
      : advState === 1
      ? advList.adv_uncheckList
      : advList.adv_deletedList
  }
  render() {
    const SORT = 'order'
    const TITLE = 'title'
    const PRICE = 'price'
    const LINK = 'url'
    const { loading, isTyping, isIdxTyping, currentPage, pageSize } = this.state
    const { advList, advState } = this.props
    const List = this.getAdvList(advState, advList)
    const isScrollStyle =
      List && List.length > 2 ? 'advManageGoodsIsScroll' : 'advManageGoods'
    return (
      <div className={isScrollStyle}>
        {loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <React.Fragment>
            {List &&
              List.slice(
                (currentPage - 1) * pageSize,
                (currentPage - 1) * pageSize + pageSize
              ).map((item, idx) => {
                return (
                  <div className="advManageCardBox advManageCard" key={idx}>
                    {advState === 3 || advState === 2 ? (
                      <div className="carBoxSort flexDisplay">
                        <div className="advContentTitle">排序:</div>
                        {isTyping === SORT && isIdxTyping === idx
                          ? this.returnEditingEle('num', item.order, item)
                          : this.returnEditEle(item.order, SORT, item, idx)}
                      </div>
                    ) : (
                      ''
                    )}
                    <div className="carBoxTitle flexDisplay">
                      <div className="advContentTitle">标题:</div>
                      {isTyping === TITLE && isIdxTyping === idx
                        ? this.returnEditingEle('string', item.title, item)
                        : this.returnEditEle(item.title, TITLE, item, idx)}
                    </div>
                    <div className="carBoxPrice flexDisplay">
                      <div className="advContentTitle">价格:</div>
                      {isTyping === PRICE && isIdxTyping === idx
                        ? this.returnEditingEle('string', item.price, item)
                        : this.returnEditEle(item.price, PRICE, item, idx)}
                    </div>
                    <div className="carBoxLink flexDisplay">
                      <div className="advContentTitle">链接:</div>
                      {isTyping === LINK && isIdxTyping === idx
                        ? this.returnEditingEle('string', item.url, item)
                        : this.returnEditEle(item.url, LINK, item, idx)}
                    </div>
                    <div className="carBoxBottom flexDisplay">
                      <div className="advContentTitle">图片:</div>
                      <div className="carBoxContent displayFlexRow">
                        <div className="carBoxIMg displayFlexRow">
                          <div className="carBoxShowImg">
                            <img
                              src={`${IMAGE_DOMAIN}${item.image_url}`}
                              alt={item.title}
                              onError={this.handleNoImg}
                            />
                          </div>
                          <Upload
                            action="//up-z0.qbox.me/"
                            data={{ token: this.state.qiuNiuToken }}
                            beforeUpload={this.beforeUpload}
                            onChange={(e) => this.handleReUpload(e, item.id)}
                            showUploadList={false}
                          >
                            <Button type="link" size="small">
                              重新上传
                            </Button>
                          </Upload>
                        </div>
                        <div className="carBoxButton displayFlexRow">
                          {advState === 1 ? (
                            <Button
                              size="small"
                              style={{ marginRight: '.5rem' }}
                              disabled={true}
                            >
                              待审核
                            </Button>
                          ) : (
                            <Popconfirm
                              title="你确定要执行此操作吗?"
                              onConfirm={() =>
                                this.handleChangeAdvState(item.id, advState)
                              }
                              okText="确定"
                              cancelText="取消"
                            >
                              <Button
                                size="small"
                                style={{ marginRight: '.5rem' }}
                              >
                                {advState === 3
                                  ? '撤回'
                                  : advState === 2
                                  ? '发布'
                                  : advState === 1
                                  ? '通过'
                                  : '恢复'}
                              </Button>
                            </Popconfirm>
                          )}
                          {advState === 4 ? (
                            ''
                          ) : (
                            <Popconfirm
                              title="你确定要删除吗?"
                              onConfirm={() =>
                                this.handleChangeAdvState(item.id, advState, 4)
                              }
                              okText="确定"
                              cancelText="取消"
                            >
                              <Button size="small" type="primary" danger>
                                删除
                              </Button>
                            </Popconfirm>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            <Pagination
              className="pageChose"
              hideOnSinglePage={true}
              total={List && List.length}
              pageSize={pageSize}
              size="small"
              current={currentPage}
              onChange={this.handleChangePage}
            />
          </React.Fragment>
        )}
      </div>
    )
  }
}

export default AdvManageGoods



// WEBPACK FOOTER //
// ./src/containers/CheckOutAdvManage/components/AdvManageGoods.js